/* eslint-disable no-restricted-imports */
import { AddLiquidity } from './actions/addLiquidity';
import { AddLiquidityETH } from './actions/ETH/addLiquidityETH';
import { SimpleAddLiquidity } from './actions/simpleAddLiquidity';
import { RemoveLiquidityETH } from './actions/ETH/removeLiquidityETH';
import { UniswapV2SwapETHForExactTokens } from './actions/ETH/UniswapV2SwapETHForExactTokens';
import { UniswapV2SwapExactETHForTokens } from './actions/ETH/UniswapV2SwapExactETHForTokens';
import { UniswapV2SwapExactTokensForETH } from './actions/ETH/UniswapV2SwapExactTokensForETH';
import { UniswapV2SwapTokensForExactETH } from './actions/ETH/UniswapV2SwapTokensForExactETH';
import { RemoveLiquidity } from './actions/removeLiquidity';
import { SimpleRemoveLiquidity } from './actions/simpleRemoveLiquidity';
import { SimpleSwapV2 } from './actions/SimpleSwapV2';
import { SimpleSwapExactInputWithFeeV2 } from './actions/SimpleSwapExactInputWithFeeV2';
import { UniswapV2SwapExactTokensForTokens } from './actions/UniswapV2SwapExactTokensForTokens';
import { UniswapV2SwapTokensForExactTokens } from './actions/UniswapV2SwapTokensForExactTokens';
import { GetAmountsIn } from './getters/GetAmountsIn';
import { GetAmountsOut } from './getters/GetAmountsOut';
import { GetReserves } from './getters/GetReserves';
import { GetPair } from './getters/GetPair';
var actions = {
    SimpleSwapV2: SimpleSwapV2,
    SimpleSwapExactInputWithFeeV2: SimpleSwapExactInputWithFeeV2,
    AddLiquidity: AddLiquidity,
    AddLiquidityETH: AddLiquidityETH,
    SimpleAddLiquidity: SimpleAddLiquidity,
    RemoveLiquidity: RemoveLiquidity,
    RemoveLiquidityETH: RemoveLiquidityETH,
    UniswapV2SwapExactETHForTokens: UniswapV2SwapExactETHForTokens,
    UniswapV2SwapETHForExactTokens: UniswapV2SwapETHForExactTokens,
    UniswapV2SwapExactTokensForETH: UniswapV2SwapExactTokensForETH,
    UniswapV2SwapTokensForExactETH: UniswapV2SwapTokensForExactETH,
    UniswapV2SwapExactTokensForTokens: UniswapV2SwapExactTokensForTokens,
    UniswapV2SwapTokensForExactTokens: UniswapV2SwapTokensForExactTokens,
    SimpleRemoveLiquidity: SimpleRemoveLiquidity,
};
var getters = {
    GetAmountsIn: GetAmountsIn,
    GetAmountsOut: GetAmountsOut,
    GetReserves: GetReserves,
    GetPair: GetPair,
};
var Uniswap = {
    actions: actions,
    getters: getters,
};
export { Uniswap };
